module.exports = __webpack_public_path__ + "img/no_data.455c78f0.png";